// Backend `Base.Models.ApiKeyStatus` is decorated with `[JsonConverter(typeof(JsonStringEnumConverter))]`,
// so the API always sends/accepts the enum member name as a string, not its numeric value.
export enum ApiKeyStatus {
  Active = 'Active',
  Revoked = 'Revoked',
  Expired = 'Expired',
  Inactive = 'Inactive',
}

export interface IApiKey {
  id: string
  servicePrincipalId: string
  name?: string
  keyPrefix: string
  expiresAt?: string | null
  status: ApiKeyStatus
  createdBy: string
  createdAt: string
  modifiedBy?: string | null
  modifiedAt?: string | null
}

export interface IApiKeyCreated extends IApiKey {
  rawKey: string
}

export interface CreateApiKeyDto {
  name?: string
  expiresAt?: string | null
}

export interface UpdateApiKeyDto {
  name?: string
  status?: ApiKeyStatus
  expiresAt?: string | null
}

export interface IApiKeyClaim {
  productClaimId: string
  claimType: string
  claimValue: string
}

export interface ApiKeyClaimsResponse {
  apiKeyId: string
  hasScopedClaims: boolean
  claims: IApiKeyClaim[]
}

export interface GetApiKeysParams {
  status?: ApiKeyStatus | 'all'
}
